/**
 * The "Try the full plan" sandbox.
 *
 * `/try` on the app mints a REAL but disposable Heirloom (`plan: "pro"`) event
 * — see api/routes/sandbox.routes.mjs. It is seeded with a full Planning Hub
 * (categories, milestones, vendors with logged activity, tasks, payments,
 * documents and decisions — api/services/sandbox-seed.service.mjs), belongs to
 * nobody, and is swept away on a TTL. That makes it the one honest way to show
 * a planning workspace to somebody who has not paid: not a screenshot of the
 * product, the product.
 *
 * ONE thing the sandbox deliberately does NOT include: Éros. The assistant
 * router blocks `req.event.isSandbox` outright (an anonymous, disposable demo
 * is an uncontrolled AI-spend vector), so any copy pointing here must say so
 * rather than implying the whole plan is on offer.
 *
 * One owner, for the same reason `demoInvitation.js` has one: the homepage
 * pricing card and /wedding-planning both send visitors to the same place, and
 * two hand-built copies of a URL are two chances to drift.
 *
 * @param {"en"|"el"} [shortLang] short language code; omitted leaves the choice
 *   to the app's own detection.
 * @returns {string} absolute URL of the sandbox entry point
 */
export const buildSandboxUrl = (shortLang) => {
  const base = (
    import.meta.env.VITE_APP_URL || "https://app.agapae.gr"
  ).replace(/\/$/, "");
  const prefixed = base.startsWith("http") ? base : `https://${base}`;
  const query = shortLang ? `?lang=${shortLang}` : "";
  return `${prefixed}/try${query}`;
};

export default buildSandboxUrl;
